export default __webpack_public_path__ + "static/media/single-project-page-05-img-18.5b58b7ee.jpg";